import { projects } from "@/data/portfolioData";
import { useReveal } from "@/hooks/useReveal";
import { SkillIcon } from "./icons/SkillIcons";
import { BugHuntGame } from "./games/BugHuntGame";

function ProjectsLocked({ games }) {
  const {
    shootOpen,
    projectsWrong,
    startShoot,
    closeShoot,
    claimShootVictory,
    tryApply,
    tryPush,
    tryCommit,
  } = games;

  const cardClass = shootOpen
    ? "mx-auto mb-5 max-w-[820px] rounded-[20px] border-3 border-ink bg-yellow p-6 shadow-neo-lg md:p-8"
    : "mx-auto mb-5 max-w-[640px] rounded-[20px] border-3 border-ink bg-yellow p-10 shadow-neo-lg";

  return (
    <div className={cardClass}>
      {!shootOpen && (
        <>
          <p className="mb-3 font-display text-xl text-ink">🔒 Case studies are locked.</p>
          <p className="mb-5 text-base leading-relaxed text-ink">
            Which command actually applies your Terraform changes?
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              onClick={tryApply}
              className="cursor-pointer rounded-[10px] border-3 border-ink bg-ink px-5 py-3 font-display text-sm text-yellow transition-transform hover:-translate-y-0.5"
            >
              terraform apply
            </button>
            <button
              type="button"
              onClick={tryPush}
              className="cursor-pointer rounded-[10px] border-3 border-ink bg-ink px-5 py-3 font-display text-sm text-yellow transition-transform hover:-translate-y-0.5"
            >
              terraform push
            </button>
            <button
              type="button"
              onClick={tryCommit}
              className="cursor-pointer rounded-[10px] border-3 border-ink bg-ink px-5 py-3 font-display text-sm text-yellow transition-transform hover:-translate-y-0.5"
            >
              terraform commit
            </button>
          </div>
          {projectsWrong && (
            <p className="mt-2.5 text-[13px] font-bold text-ink">
              nope, that&apos;ll break the pipeline. try again.
            </p>
          )}
          <p className="mb-2 mt-[22px] font-display text-xs text-ink opacity-60">or</p>
          <button
            type="button"
            onClick={startShoot}
            className="cursor-pointer rounded-[10px] border-3 border-ink bg-ink px-5 py-3 font-display text-sm text-yellow transition-transform hover:-translate-y-0.5 hover:scale-[1.02]"
          >
            🎯 Play the bug hunt
          </button>
        </>
      )}

      {shootOpen && (
        <BugHuntGame onVictory={claimShootVictory} onQuit={closeShoot} />
      )}
    </div>
  );
}

function ProjectsGrid() {
  const revealRef = useReveal();

  return (
    <div
      ref={revealRef}
      className="work-grid grid grid-cols-1 gap-6 md:grid-cols-3"
    >
      {projects.map((project) => (
        <a
          key={project.title}
          href={project.href}
          target="_blank"
          rel="noopener noreferrer"
          className="neo-card neo-card-hover overflow-hidden rounded-[18px] no-underline hover:text-teal"
        >
          <div
            className={`flex h-[140px] items-center justify-center border-b-3 border-ink ${project.color}`}
          >
            <SkillIcon
              name={project.icon}
              className={`h-[60px] w-[60px] scale-[2] ${project.iconLight ? "text-white" : "text-ink"}`}
            />
          </div>
          <div className="p-6">
            <h3 className="mb-2 font-display text-[19px] text-ink">{project.title}</h3>
            <p className="mb-3.5 text-[15px] leading-normal text-muted2">{project.description}</p>
            <span className="text-sm font-bold text-teal">View on GitHub →</span>
          </div>
        </a>
      ))}
    </div>
  );
}

export function ProjectsSection({ games }) {
  return (
    <section className="relative z-[2] px-6 pb-[70px] pt-8 md:px-14">
      <p className="mb-1.5 text-center text-base font-bold text-teal">Selected case studies</p>
      <h2 className="mb-11 text-center font-display text-[44px] text-ink">Projects</h2>

      {!games.projectsUnlocked ? (
        <ProjectsLocked games={games} />
      ) : (
        <ProjectsGrid />
      )}
    </section>
  );
}
